let hidden: string
let visibilityChange: string

if (document) {
	if (typeof document.hidden !== 'undefined') {
		hidden = 'hidden'
		visibilityChange = 'visibilitychange'
	}
}

const waitForReconnection = () =>
	new Promise<void>((resolve) => {
		function handleChange() {
			if (!document.hidden) {
				document.removeEventListener(visibilityChange, handleChange, false)
				resolve()
			}
		}
		document.addEventListener(visibilityChange, handleChange, false)
	})

const isHidden = () => isSupported() && document.hidden

const isSupported = () => !!hidden

const onChange = (callback: () => void) => {
	document.addEventListener(visibilityChange, callback, false)
}

export default {
	waitForReconnection,
	isHidden,
	isSupported,
	onChange,
}
